export const replaceCityCodes = [
  '877',
  '872',
  '856',
  '873',
  '866',
  '847',
  '878',
  '814',
  '821',
  '857',
  '836',
  '834',
  '867',
  '843',
  '855',
  '871',
  '835',
  '861',
  '862',
  '865',
  '879',
  '818',
  '851',
  '844',
  '817',
  '820',
  '810',
  '833',
  '813',
  '815',
  '831',
  '816',
  '841',
  '811',
  '863',
  '846',
  '848',
  '845',
  '842',
  '860',
  '812',
  '869',
  '818',
]

const applyMask = (value, mask) => {
  let result = ''
  let maskCounter = 0
  let valueCounter = 0

  const placeholderValidators = {
    '#': (char) => char.match(/^\d$/),
  }

  while (true) {
    if (maskCounter >= mask.length) {
      if (valueCounter >= value.length) break
      result += value[valueCounter]
      valueCounter += 1
    } else {
      const validator = placeholderValidators[mask[maskCounter]]
      if (validator) {
        if (valueCounter >= value.length) break
        const valid = validator(value[valueCounter])
        if (valid) {
          result += value[valueCounter]
          maskCounter += 1
        }
        valueCounter += 1
      } else {
        result += mask[maskCounter]
        maskCounter += 1
      }
    }
  }
  return result
}

export const applyPhoneMask = (value, prevValue, mask) => {
  if ((value || '').length > (prevValue || '').length) {
    let clearedValue = (value || '').replace(/\D/gi, '')
    if (clearedValue.startsWith('7')) {
      clearedValue = clearedValue.slice(1)
    } else if (clearedValue.startsWith('8')) {
      if (!replaceCityCodes.includes(clearedValue.slice(0, 3))) {
        clearedValue = clearedValue.slice(1)
      }
    }

    value = applyMask(clearedValue, mask)
    value = value.slice(0, mask.length)
  }
  return value
}
